module.exports = {
	"_args": [
		[
			"shift-parser@https://registry.npmjs.org/shift-parser/-/shift-parser-4.1.0.tgz",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "shift-parser@>=4.1.0 <5.0.0",
	"_id": "shift-parser@4.1.0",
	"_inCache": true,
	"_location": "/shift-parser",
	"_phantomChildren": {},
	"_requested": {
		"name": "shift-parser",
		"raw": "shift-parser@https://registry.npmjs.org/shift-parser/-/shift-parser-4.1.0.tgz",
		"rawSpec": "https://registry.npmjs.org/shift-parser/-/shift-parser-4.1.0.tgz",
		"scope": null,
		"spec": "https://registry.npmjs.org/shift-parser/-/shift-parser-4.1.0.tgz",
		"type": "remote"
	},
	"_requiredBy": [
		"/"
	],
	"_resolved": "https://registry.npmjs.org/shift-parser/-/shift-parser-4.1.0.tgz",
	"_shasum": "1de50f56f3bc2da678d1e8f1ed506c71e07a4411",
	"_shrinkwrap": null,
	"_spec": "shift-parser@https://registry.npmjs.org/shift-parser/-/shift-parser-4.1.0.tgz",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"name": "Shape Security Labs"
	},
	"bugs": {
		"url": "https://github.com/shapesecurity/shift-parser-js/issues"
	},
	"dependencies": {
		"es6-map": "^0.1.1",
		"esutils": "^2.0.2",
		"multimap": "^0.1.1",
		"shift-reducer": "^3.0.2"
	},
	"description": "ECMAScript parser that produces a Shift format AST",
	"devDependencies": {
		"acorn": "2.1.0",
		"angular": "1.4.3",
		"babel-cli": "6.3.13",
		"babel-preset-es2015": "6.3.13",
		"babel-register": "6.3.13",
		"benchmark": "1.0.0",
		"commonjs-everywhere": "0.9.7",
		"esprima": "2.5.0",
		"everything.js": "1.0.3",
		"expect.js": "0.3.1",
		"microtime": "^2.0.0",
		"mocha": "2.2.5",
		"shift-spec": "2015.2.1",
		"tick": "0.1.1",
		"traceur": "0.0.91",
		"uglifyjs": "2.4.10"
	},
	"files": [
		"dist"
	],
	"homepage": "https://github.com/shapesecurity/shift-parser-js",
	"keywords": [
		"API",
		"AST",
		"Parser",
		"Shift",
		"SpiderMonkey",
		"abstract",
		"monkey",
		"node",
		"parse",
		"parser",
		"spider",
		"syntax",
		"tree"
	],
	"license": "Apache-2.0",
	"main": "dist/index.js",
	"name": "shift-parser",
	"optionalDependencies": {},
	"readme": "Shift Parser\n============\n\n\n## About\n\nThis module provides an [ECMAScript](http://www.ecma-international.org/publications/standards/Ecma-262.htm)\nparser that produces a [Shift format](https://github.com/shapesecurity/shift-spec) AST.\n\n\n## Status\n\n[Stable](http://nodejs.org/api/documentation.html#documentation_stability_index).\n\nThe parser supports version 6 (release candidate 2) of the ECMA-262 standard.\n\n\n## Installation\n\n```sh\nnpm install shift-parser\n```\n\n\n## Usage\n\n```es6\nimport parse from \"shift-parser\";\nlet ast = parse(\"/* ECMAScript program text */\");\n```\n\n```es6\nimport {parseScript, parseModule} from \"shift-parser\";\nlet scriptAST = parseScript(\"/* ECMAScript Script text */\");\nlet moduleAST = parseModule(\"/* ECMAScript Module text */\");\n```\n\nOr in node.js:\n\n```js\nvar parseScript = require(\"shift-parser\").parseScript;\nvar scriptAST = parseScript(\"/* ECMAScript Script text */\");\n```\n\n\n## Contributing\n\n* Open a Github issue with a description of your desired change. If one exists already, leave a message stating that you are working on it with the date you expect it to be complete.\n* Fork this repo, and clone the forked repo.\n* Install dependencies with `npm install`.\n* Build and test in your environment with `npm run build && npm test`.\n* Create a feature branch. Make your changes. Add tests.\n* Build and test in your environment with `npm run build && npm test`.\n* Make a commit that includes the text \"fixes #*XX*\" where *XX* is the Github issue.\n* Open a Pull Request on Github.\n\n\n## License\n\n    Copyright 2014 Shape Security, Inc.\n\n    Licensed under the Apache License, Version 2.0 (the \"License\");\n    you may not use this file except in compliance with the License.\n    You may obtain a copy of the License at\n\n        http://www.apache.org/licenses/LICENSE-2.0\n\n    Unless required by applicable law or agreed to in writing, software\n    distributed under the License is distributed on an \"AS IS\" BASIS,\n    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n    See the License for the specific language governing permissions and\n    limitations under the License.\n",
	"readmeFilename": "README.md",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/shapesecurity/shift-parser-js.git"
	},
	"scripts": {
		"benchmark": "node benchmark",
		"build": "babel --source-maps-inline --out-dir dist src",
		"cjsify": "npm run build && cjsify dist/index.js --no-node --export Shift --output dist/shift.js",
		"prepublish": "rm -rf dist/* && npm update && npm run build",
		"profile": "node --prof profile.js && node-tick-processor",
		"test": "mocha --inline-diffs --check-leaks --ui tdd --reporter dot --slow 200 --timeout 5000 --recursive test"
	},
	"version": "4.1.0"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/shift-parser/package.json
 ** module id = ./node_modules/shift-parser/package.json
 ** module chunks = 0
 **/